import { useEffect, useState } from 'react';
import { GitMerge } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useServices } from '../../app/services';
import { Card, List, ListRow } from '../../ui';
import './activity.css';

/** On Home: conflicts waiting in the budget on screen, one tap from the activity screen. Nothing when there are none. */
export function ConflictNotice() {
  const { t } = useTranslation();
  const { store, activeSpace, dataVersion } = useServices();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!activeSpace) return;
    let live = true;
    void store.activity.openConflicts(activeSpace.id).then((list) => live && setCount(list.length));
    return () => {
      live = false;
    };
  }, [store, activeSpace, dataVersion]);
  if (!activeSpace || count === 0) return null;
  return (
    <Card flush className="home-notice">
      <List inset>
        <ListRow
          leading={<GitMerge size={18} aria-hidden />}
          title={t('activity.needsLook', { count })}
          subtitle={t('activity.needsLookBody')}
          to={`/budgets/${activeSpace.id}/activity`}
        />
      </List>
    </Card>
  );
}
